import React, { Component } from 'react'
import {Col , Row , Divider, Button, Result, message , Modal} from 'antd'
import EmployeeDetails from './EmployeeDetails'
import SalesDetails from './SalesDetails'
import employeeStore from '../../../store/EmployeeStore'
import Axios from 'axios'
import keys from '../../../keys'
import { fetchEmployees } from '../../../redux/employee/actions/actionCreators'
import { connect } from 'react-redux'

const {confirm} = Modal



class EmployeeProfile extends Component{

    state = {
        "is_edit_mode" : false,
        "avatar" : 'img/man.svg',
        "data": null,
        }

    componentDidMount(){
        Axios.get(`${keys.server}/hr/employee/${this.props.EmployeeID}/profile`)
        .then( response => {
            this.setState({
                data : response.data
            })
        })
        .catch(
            error => {
                console.error(error)
                message.error("Fetching employee profile failed!")
            }
        )
    }

      showDeleteConfirm = (employee_id) =>  {
            const {server} = this.props.entity
            const {fetchEmployees} = this.props
            confirm({
              title: 'Are you sure delete this Employee?',
              content: 'You can\'t this employee back once you delete',
              okText: 'Yes',
              okType: 'danger',
              cancelText: 'No',
              onOk() {
                Axios.delete(
                    `${server}/user/employee/${employee_id}`  
                )
                .then(
                    result => {
                        message.success("Employee Deleted Successfully")
                        message.loading("Loading employees..")
                        fetchEmployees(
                            () => { 
                                message.destroy()
                                message.success("Loading employees success!")
                            },
                            () =>{ 
                                message.destroy()
                                message.error("Loading employee failed")
                            }

                        )
                    }
                )
                .catch(
                    err => {
                        console.log(err);
                        message.error("Oops! Something went wrong with deleitng this employee")
                    }
                )
              },
              onCancel() {
                console.log('Cancel');
              },
            });
          }  

    onPayrollClicked = ()=>{
        this.props.history.push(`employee/${this.props.EmployeeID}/payroll`)
    }
    onEditClicked = ()=>{
        this.props.history.push(`employee/${this.props.EmployeeID}/edit`)
    }
    
    render(){
      
        const {data} =  this.state //employeeStore.getEmployeeByID(this.props.EmployeeID).pop()
        
        return(
                data ?
                <div>   
                    <EmployeeDetails {...data}/>
                        <Divider></Divider>
                    {/* <Row>
                    <SalesDetails EmployeeID = {data.id}/> 
                    </Row> */}
            
                    <Row style={{padding:"10px 0px"}} >
                
                        <Col span={4}><Button onClick={this.onPayrollClicked} type="primary"> Pay Roll</Button></Col>                           
                        <Col offset={12} span={3}> <Button onClick={this.onEditClicked}  type="danger" ghost>Edit</Button></Col>
                        <Col   span={4}> <Button type="danger" onClick={() => this.showDeleteConfirm(this.props.EmployeeID)} >Delete</Button></Col>
                    </Row>
                </div> : <div></div>
            
           
        )
        
        
    }

}


const mapStateToProps = state => ({entity : state.entity})

const mapDispatchToProps = dispatch => ({fetchEmployees : (successCallback, errorCallback) => dispatch(fetchEmployees(successCallback, errorCallback))})

export default connect(mapStateToProps,null)(EmployeeProfile);